const HALO_INFO_SCORE_DESCRIPTION =
  'Halo Ai proprietary supplier score calculated across your entire portfolio of suppliers and based only on external data available for these suppliers. A high score indicates a strong standing while lower scores indicate greater risk.';

export default HALO_INFO_SCORE_DESCRIPTION;
